export const tokenAddresses = {
  EUL: "0xd9Fcd98c322942075A5C3860693e9f4f03AAE07b",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0xf3e621395fc714B90dA337AA9108771597b4E696",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
